export default function About() {
  return (
    <>
      <nav className="breadcrumbs">Accueil / À propos</nav>
      <section className="about">
        <h1>Notre histoire</h1>
          <p>
            TheTresorSafe est né d’une conviction simple : la sécurité de vos armes mérite 
            une solution fiable, robuste et pensée pour durer.
          </p>
          
          <p>
            Son fondateur, <strong>Clément Forestier</strong>, a créé la marque avec l’ambition 
            de proposer des armoires à fusils modernes, alliant normes de sécurité strictes 
            et esthétisme sobre. Passionné d’innovation et entrepreneur engagé, il a voulu 
            mettre son expérience au service d’un produit spécialisé, accessible et durable.
          </p>
          
          <p>
            Aujourd’hui, TheTresorSafe se développe en Suisse et en Europe, avec un objectif : 
            devenir la référence des armoires à fusils, en gardant toujours au cœur de son 
            engagement la <em>confiance</em> et la <em>proximité avec ses clients</em>.
          </p>
          <p>
            Pour toute questin supplémentaire, n'héstiez pas à <a href="/contact">nous contacter</a>
          </p>
      </section>
    </>
  );
}
